import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import ROUTING_PATH from 'constants/route'
import { useAuthProvider } from 'contexts/auth'
import { UserRole } from 'schema/user'
import TopLogo from './top-logo'
import { LoginUserMode, LoginUserModeEnum } from 'constants/loginusermode'
import { LOGIN_USER_MODE } from 'constants/common'

const HeaderHeight = 56
export const HeaderHeightPx = `${HeaderHeight}px`
export const HeaderContainer = styled.div<{ lum: LoginUserMode }>`
  z-index: 100;
  top: 0px;
  right: 0px;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${HeaderHeightPx};
  width: 100%;
  background-color: ${(p) =>
    p.lum === LoginUserModeEnum.Impersonation
      ? p.theme.BACKGROUND_IMPERSONATION
      : p.theme.WHITE};
  box-sizing: border-box;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
`

const BackButton = styled.button`
  width: 20px;
  height: 20px;
  position: absolute;
  left: 20px;
  background-color: transparent;
  background-image: url('/image/back-page.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border: none;
  cursor: pointer;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    left: 16px;
  }
`

interface HeaderProps {
  showBackButton?: boolean
}

const Header = ({ showBackButton = false }: HeaderProps) => {
  const { claims } = useAuthProvider()
  const navigate = useNavigate()
  const loginUserMode = localStorage.getItem(
    LOGIN_USER_MODE
  ) as LoginUserModeEnum

  const destination = useMemo(() => {
    return claims?.role === UserRole.AGENT
      ? ROUTING_PATH.C0201
      : ROUTING_PATH.B0201
  }, [claims?.role])

  return (
    <HeaderContainer lum={loginUserMode}>
      {showBackButton && <BackButton onClick={() => navigate(-1)} />}
      <TopLogo to={destination} />
    </HeaderContainer>
  )
}

export const HeaderComponent = () => (
  <HeaderContainer lum={LoginUserModeEnum.Owner}>
    <TopLogo />
  </HeaderContainer>
)

export default Header
